<template>
    <main  class="main-content">
      <router-view />
    </main>
</template>

<script>

export default {
  components: {  },
  mixins: [],
  data() {
    return {
      isOk: "",
      ok_index: "",
      index: "",
      genericModalOpen: false,
      genericTitle: "Chaos Alert",
      plainLayout:true,
      genericText:
        "This will keep the route disabled because the route list is in cache now. Now, go to route.php file and try to remove commented route.",
    };
  },
  created() {
    // this.genericModaldisplay('Chaos Alert','Chaos Alert');// this is generic call
    this.isOk = "";
  },
  watch: {
    isOk: function (value) {
      //console.log(value);
      //this.checkGlobalRoute(value);
    },
    $route(to, from) {
      // react to route changes...
      
    }
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>


